import { render } from "./ActivityEditorView.vue?vue&type=template&id=1c0c3c60"
import script from "./ActivityEditorView.vue?vue&type=script&lang=js"
export * from "./ActivityEditorView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__